import {Container, Loader} from "@mantine/core";
import {ThemedPage} from "../ThemedPage/ThemedPage";

export const LoadingPage = () => {
  return (
    <ThemedPage>
      {(classes) => (
        <Container className={classes.container} fluid={true} py="md">
          <Loader/>
        </Container>
      )}
    </ThemedPage>
  )
}
